import React from "react";
import { SVG, IconProps } from "../SVG";
export const Visa = (props: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 17" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill="#224DBA"
                d="M0 2.266A2.27 2.27 0 0 1 2.28 0h19.44A2.28 2.28 0 0 1 24 2.266v12.268a2.27 2.27 0 0 1-2.28 2.266H2.28A2.28 2.28 0 0 1 0 14.534V2.266Z"
            />
            <path
                fill="#FFF"
                d="M8.177 11.205H6.771L5.716 7.173c-.05-.186-.156-.35-.313-.427a4.571 4.571 0 0 0-1.289-.427v-.155H6.38a.59.59 0 0 1 .586.504l.547 2.909L8.92 6.164h1.367l-2.109 5.04Zm2.891 0H9.74l1.094-5.04h1.328l-1.094 5.04ZM13.88 7.56c.04-.272.274-.427.547-.427a2.47 2.47 0 0 1 1.29.232l.234-1.085a3.356 3.356 0 0 0-1.21-.233c-1.29 0-2.228.698-2.228 1.667 0 .737.664 1.124 1.133 1.358.508.232.703.387.664.62 0 .349-.39.504-.78.504-.47 0-.939-.116-1.368-.31l-.235 1.085c.47.194.977.272 1.446.272 1.445.038 2.344-.66 2.344-1.706 0-1.319-1.837-1.396-1.837-1.977Zm6.485 3.644-1.055-5.04h-1.132a.588.588 0 0 0-.548.387l-1.953 4.653h1.368l.273-.737h1.68l.156.737h1.211Zm-1.992-3.683.39 1.9H17.67l.704-1.9Z"
            />
        </g>
    </SVG>
);
Visa.displayName = "Visa";
